import { useEffect, useCallback } from 'react';
import { useNavigate } from 'react-router-dom';
import { translateFromStorage } from '../i18n/formatTranslation';
import { logoutAndRedirect } from '../utils/authLogout';

const TIMEOUT = 30 * 60 * 1000; // 30 minutes
const WARNING = 5 * 60 * 1000;  // 5 minutes warning

const useSessionTimeout = ({ pause = false } = {}) => {
  const navigate = useNavigate();

  const logout = useCallback(() => {
    alert(translateFromStorage('sessionExpiredLogin'));
    logoutAndRedirect(navigate);
  }, [navigate]);

  useEffect(() => {
    let timer;
    let warningTimer;

    const reset = () => {
      clearTimeout(timer);
      clearTimeout(warningTimer);
      if (pause) return;
      warningTimer = setTimeout(() => {
        alert(translateFromStorage('sessionExpireWarning'));
      }, TIMEOUT - WARNING);
      timer = setTimeout(logout, TIMEOUT);
    };

    const events = ['click', 'keypress', 'scroll', 'mousemove', 'touchstart'];
    events.forEach((e) => window.addEventListener(e, reset));
    reset();

    return () => {
      clearTimeout(timer);
      clearTimeout(warningTimer);
      events.forEach((e) => window.removeEventListener(e, reset));
    };
  }, [logout, pause]);
};

export default useSessionTimeout;
